module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "page_text container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8  col-xs-offset-2"
  }, [_c('g-signin-button', {
    staticClass: "csp-login btn z-depth-3 goog-login",
    attrs: {
      "params": _vm.googleSignInParams
    },
    on: {
      "success": _vm.onGoogleSignInSuccess,
      "error": _vm.onGoogleSignInError
    }
  }, [_vm._v("\n          Log in with Google\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8  col-xs-offset-2"
  }, [_c('fb-signin-button', {
    staticClass: "csp-login btn z-depth-3 fb-login",
    attrs: {
      "params": _vm.facebookSignInParams
    },
    on: {
      "success": _vm.onFacebookSignInSuccess,
      "error": _vm.onFacebookSignInError
    }
  }, [_vm._v("\n          Log in with Facebook\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8  col-xs-offset-2"
  }, [_c('amz-signin-button', {
    staticClass: "csp-login btn z-depth-3 amz-login",
    attrs: {
      "params": _vm.amazonSignInParams
    },
    on: {
      "success": _vm.onAmazonSignInSuccess,
      "error": _vm.onAmazonSigninError
    }
  }, [_vm._v("\n          Log in with Amazon\n        ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row csp-open-block csp-row-bot-h1r"
  }, [_c('div', {
    staticClass: "csp-title-id col-xs-1 col-xs-offset-2"
  }, [_c('span', [_vm._v("Client Service Portal")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row csp-row-bot-1r"
  }, [_c('div', {
    staticClass: " csp-title-text col-xs-5  col-xs-offset-2"
  }, [_c('span', [_vm._v("Please login with your prefered account below.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04eb75c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 847
// module chunks = 2